/* eslint-disable no-prototype-builtins */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Modal, Row, Col, Form, Input, Button, message, Spin } from "antd";
import axios from "axios";
import { checkNumbervalue } from "../../../utils/index";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import "./style.scss";
import {
  createChildShipment,
  getChildPacket,
  getChildPacketIds,
} from "../../../actionsMethods/cashBookingMethods";
import { APIs, getToken } from "../../../utils/worker";
import MasterModal from "../../../components/Master/Modal";

const token = getToken();

const childBaggageModal = ({
  visible,
  handleCancel,
  handleOk,
  // childData,
  awb,
  handleSubmitModal,
  serviceType,
  currentScreen,
  premiseId,
  childDetails,
  deliveryPincode,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const [childData, setchildData] = useState();
  const chidlPacket = useSelector((state) => state.childPacketReducer);
  const chidlPacketIdsResponse = useSelector(
    (state) => state.appReducer.getChildPacketIdsReducer
  );

  const { error: childIdsError, result: childIdsResult } =
    chidlPacketIdsResponse;
  let childFeildsDetails =
    childDetails &&
    childDetails?.map((val) => {
      return {
        weight: val.totalweight,
        height: val.height,
        length: val.length,
        width: val.width,
      };
    });

  let mergeArr = [];
  childData?.map((e, i) => {
    mergeArr?.push({
      ...e,
      ...childFeildsDetails[i],
    });
  });
  // console.log(mergeArr);
  const [destinationDetails, setdestinationDetails] = useState();

  const getDestinationId = async (e) => {
    try {
      let res = await axios.get(
        `${APIs.baseURL}/premise-service/v1/premise/pincode/${deliveryPincode}`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (res.data) {
        setdestinationDetails(res?.data);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };
  let allAppData = JSON.parse(localStorage.getItem("details"));

  let destinationHubId = destinationDetails?.find(
    (e) => e.premiseId == allAppData?.destinationPremiseId
  );

  const postChildPackets = async (values) => {
    let data = mergeArr?.map((val, index) => {
      return {
        childAwbNumber: val?.awbNumber,
        type: 2,
        description: "Demo Description1",
        value: 0.0,
        service: serviceType,
        weight: +val.weight,
        height: +val.height,
        length: +val.length,
        width: +val.width,
        ewayBillNumber: null,
        destinationPincode: +deliveryPincode,
        destinationCpId: allAppData?.destinationPremiseId,
        destinationHubId: destinationHubId?.parentId,
      };
    });
    try {
      let res = await axios.post(
        `${APIs.baseURL}/shipment-service/v1/shipment/${awb}/child`,
        data,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (res.data) {
        message.success("Child shipment successfully added");
        let childNums = res.data?.childShipments?.map(
          (val) => val.childAwbNumber
        );
        localStorage.setItem("childAwbNumber", JSON.stringify(childNums));
        handleSubmitModal();
      }
    } catch (error) {
      message.error(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    if (childIdsResult !== null) {
      setchildData(childIdsResult);
    }
  }, [childIdsResult]);

  useEffect(() => {
    if (awb) {
      dispatch(getChildPacketIds(6, chidlPacket?.val, premiseId));
      getDestinationId();
    }
  }, [awb, chidlPacket?.val]);

  return (
    <div className="child-baggage">
      <MasterModal
        title="Child Packets"
        visible={visible}
        width={800}
        onOk={handleOk}
        loading={chidlPacketIdsResponse?.fetching}
        okText={"Save"}
        maskClosable={false}
        footer={
          <>
            <Button onClick={handleCancel} className="next-button">
              {"cancel"}
            </Button>
            <Button
              htmlType="submit"
              form={form}
              className="next-button"
              style={{ background: "#2E77D0", color: "white" }}
            >
              {"Submit"}
            </Button>
          </>
        }
        handleCloseModal={handleCancel}
        className="child-modal"
        content={
          <>
            <p>{childIdsError?.message}</p>
            <Form onFinish={postChildPackets} name={form}>
              <Row>
                {childData?.map((val, index) => {
                  return (
                    <>
                      <Col
                        lg={12}
                        md={12}
                        xl={12}
                        // offset={1}
                        className="input-items"
                      >
                        <Form.Item label={index + 1} name={val?.awbNumber}>
                          <Input defaultValue={val?.awbNumber} disabled />
                        </Form.Item>
                      </Col>
                    </>
                  );
                })}
              </Row>
            </Form>
          </>
        }
      ></MasterModal>
    </div>
  );
};
export default childBaggageModal;
